<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (displayOptions) {
  <div [class.detract-attention]="!quote" data-zid="options-container">
    <div class="d-md-flex justify-content-between mt-1 mb-2 optional">
      @if (isSell) {
        <ng-container *ngTemplateOutlet="option; context: { option: 'tsl', isActive: true }" />
      }
      <ng-container
        *ngTemplateOutlet="option; context: { option: isSell ? 'oco' : 'leverage', isActive: isSell ? true : isLeverageOptionAvailable }"
      />
      <ng-container *ngTemplateOutlet="option; context: { option: 'limit', isActive: true }" />
      <ng-container *ngTemplateOutlet="option; context: { option: 'stop', isActive: true }" />
    </div>
  </div>
}

<ng-template #option let-option="option" let-isActive="isActive">
  <div
    class="btn btn-success mb-2 mb-md-0 d-flex justify-content-md-center align-items-center"
    [class.disabled]="!isActive"
    (click)="toggle(option, isActive)"
    [attr.data-zid]="option + '-order'"
  >
    <svg class="icon icon-18 mr-2">
      <use [attr.xlink:href]="type === option ? '/assets/img/svgs/svgset.svg#minus' : '/assets/img/svgs/svgset.svg#plus'" />
    </svg>
    <span class="font-medium">
      {{ 'trade.create.options.' + option + '.label' | transloco }}
      @if (type === option) {
        <span class="hidden-md hidden-lg hidden-xl">{{ 'trade.create.options.de-select' | transloco }}</span>
      }
    </span>
  </div>
</ng-template>

@if (hasFraction && type !== 'market' && type !== 'leverage') {
  <div class="mt-3">
    <span class="text-color-error">
      {{ 'trade.create.options.fraction.not-allowed' | transloco }}
    </span>
  </div>
} @else {
  @switch (type) {
    @case ('leverage') {
      <ng-container *ngTemplateOutlet="leverage" />
    }
    @case ('limit') {
      @if (mode === 'value') {
        <div class="mt-3">
          <span class="text-color-error" data-zid="error-limit-mode">{{ 'trade.create.options.limit.not-allowed' | transloco }}</span>
          <a class="link link-secondary cursor-pointer text-default ml-1" (click)="changeMode.emit('quantity')">Jetzt ändern</a>
        </div>
      }
      <div class="mt-3 limit-form" [class.active]="mode !== 'value'" [formGroup]="form">
        <ng-container *ngTemplateOutlet="editOrderHint" />
        <div class="mb-4">
          {{ 'trade.create.options.limit.' + direction + '.hint' | transloco }}
        </div>
        <div class="input-group-material keepcolor">
          <input
            id="limit"
            formControlName="limitPrice"
            type="number"
            [placeholder]="'trade.create.options.limit.placeholder' | transloco"
          />
          <label for="limit">
            {{ 'trade.create.options.limit.placeholder' | transloco }}
          </label>
        </div>
      </div>
    }
    @case ('stop') {
      @if (mode === 'value') {
        <div class="mt-3">
          <span class="text-color-error" data-zid="error-stop-mode">{{ 'trade.create.options.stop.not-allowed' | transloco }}</span>
          <a class="link link-secondary cursor-pointer text-default ml-1" (click)="changeMode.emit('quantity')">Jetzt ändern</a>
        </div>
      }
      <div class="mt-3 stop-form" [class.active]="mode !== 'value'" [formGroup]="form">
        <ng-container *ngTemplateOutlet="editOrderHint" />
        <div class="mb-4">
          {{ 'trade.create.options.stop.' + direction + '.hint' | transloco }}
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="input-group-material keepcolor">
              <input
                id="stop"
                formControlName="stopPrice"
                type="number"
                [placeholder]="'trade.create.options.stop.stop-placeholder' | transloco"
              />
              <label for="stop">
                {{ 'trade.create.options.stop.stop-label' | transloco }}
              </label>
            </div>
          </div>
          <div class="col-12 col-md-6 mt-4 mt-md-0">
            <div class="input-group-material keepcolor">
              <input
                id="stopLimit"
                formControlName="stopLimitPrice"
                type="number"
                [placeholder]="'trade.create.options.stop.stopLimit-placeholder' | transloco"
              />
              <label for="stopLimit">
                {{ 'trade.create.options.stop.' + direction + '.stopLimit-label' | transloco }}
              </label>
            </div>
          </div>
        </div>
        @if (form.hasError('stopLimit')) {
          <div class="row">
            <div class="col-12 text-center mt-1 text-color-error" data-zid="error-stop-limit">
              {{ form.getError('stopLimit') | transloco }}
            </div>
          </div>
        }
      </div>
    }
    @case ('oco') {
      @if (isNotSupported) {
        <ng-container *ngTemplateOutlet="execTypeNotSupportedHint" />
      } @else {
        <div class="mt-3" [formGroup]="form">
          <div class="mb-4">
            {{ 'trade.create.options.oco.hint' | transloco }}
          </div>
          <div class="row">
            <div class="col-12 pt-2">
              <div class="input-group-material keepcolor">
                <input
                  id="stopLoss"
                  formControlName="stopLoss"
                  type="number"
                  [placeholder]="'trade.create.options.oco.stopLoss.placeholder' | transloco"
                />
                <label for="stopLoss">
                  {{ 'trade.create.options.oco.stopLoss.label' | transloco }}
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 pt-2">
              <div class="input-group-material keepcolor">
                <input
                  id="takeProfit"
                  formControlName="takeProfit"
                  type="number"
                  [placeholder]="'trade.create.options.oco.takeProfit.placeholder' | transloco"
                />
                <label for="takeProfit">
                  {{ 'trade.create.options.oco.takeProfit.label' | transloco }}
                </label>
              </div>
            </div>
          </div>
          @if (form.hasError('oco')) {
            <div class="row">
              <div class="col-12 text-center mt-4 text-color-error">
                {{ form.getError('oco') | transloco }}
              </div>
            </div>
          }
        </div>
      }
    }
    @case ('tsl') {
      @if (isNotSupported) {
        <ng-container *ngTemplateOutlet="execTypeNotSupportedHint" />
      } @else {
        <div class="mt-3" [formGroup]="form">
          <div class="mb-4" [innerHTML]="'trade.create.options.tsl.hint' | transloco"></div>
          <div class="row">
            <div class="col-12 pt-2">
              <div class="input-group-material keepcolor">
                <input
                  id="initialStopPrice"
                  formControlName="initialStopPrice"
                  type="number"
                  [placeholder]="'trade.create.options.tsl.initialStopPrice.placeholder' | transloco"
                />
                <label for="initialStopPrice">
                  {{ 'trade.create.options.tsl.initialStopPrice.label' | transloco }}
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="d-flex justify-content-between align-items-center">
                <div class="nav-tabs mb-1 mt-0 no-select">
                  <div class="nav-item mr-sm-2">
                    <a
                      class="nav-link text-nowrap font-medium"
                      [class.active]="form.get('trailingType').value === 'rel'"
                      (click)="toggleTrailingType('rel')"
                    >
                      {{ 'trade.create.options.tsl.trailing.nav.rel' | transloco }}
                    </a>
                  </div>
                  <div class="nav-item ml-1">
                    <a
                      class="nav-link text-nowrap font-medium"
                      [class.active]="form.get('trailingType').value === 'abs'"
                      (click)="toggleTrailingType('abs')"
                    >
                      {{ 'trade.create.options.tsl.trailing.nav.abs' | transloco }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            @if (form.get('trailingType').value === 'abs') {
              <div class="col-12 pt-2">
                <div class="input-group-material keepcolor">
                  <input
                    formControlName="trailingAbs"
                    type="number"
                    [placeholder]="'trade.create.options.tsl.trailing.trailingAbs' | transloco"
                    (keyup)="updateRel()"
                  />
                </div>
              </div>
            }
            @if (form.get('trailingType').value === 'rel') {
              <div class="col-12 pt-2">
                <div class="input-group-material keepcolor">
                  <input
                    formControlName="trailingRel"
                    type="number"
                    [placeholder]="'trade.create.options.tsl.trailing.trailingRel' | transloco"
                    (keyup)="updateAbs()"
                  />
                </div>
              </div>
            }
          </div>
          @if (form.hasError('tsl')) {
            <div class="row">
              <div class="col-12 text-center mt-4 text-color-error">
                {{ form.getError('tsl') | transloco }}
              </div>
            </div>
          }
        </div>
      }
    }
  }
}

<ng-template #leverage>
  <div class="mt-3">
    {{ 'leverage-products.hint.start' | transloco: { name: asset.name } }}
    <div class="icon-tooltip-wrapper">
      <span class="d-flex justify-content-center align-items-end">
        <svg class="icon icon-14 cursor-pointer" (click)="displayLeverageTooltip = !displayLeverageTooltip">
          <use xlink:href="/assets/img/svgs/svgset.svg#info" />
        </svg>
      </span>
      <span>.</span>
      @if (displayLeverageTooltip) {
        <div class="icon-tooltip-content text-left icon-tooltip-content--show autoheight">
          <div class="icon-tooltip-close" (click)="displayLeverageTooltip = !displayLeverageTooltip">
            <svg class="icon icon-14">
              <use xlink:href="/assets/img/svgs/svgset.svg#close" />
            </svg>
          </div>
          <p>
            {{ 'leverage-products.hint.tooltip' | transloco }}
          </p>
        </div>
      }
    </div>
    {{ 'leverage-products.hint.end' | transloco }}
  </div>
  <leverage-products [name]="asset.name" [isin]="asset.isin" />
</ng-template>

@if (displayOptions) {
  <hr class="mt-4" />
}

<ng-template #editOrderHint>
  @if (form.get('isEditOrder')?.value) {
    <div class="mt-2 mb-2 p-2 text-align-center font-size-smaller1 border-error text-danger">
      {{ 'trade.create.options.edit-order' | transloco }}
    </div>
  }
</ng-template>

<ng-template #execTypeNotSupportedHint>
  <div class="mt-3">
    <span class="text-color-error" data-zid="not-supported-hint">{{
      'trade.create.options.' + type + '.not-supported'
        | transloco
          : {
              exchange: asset?.marketName,
            }
    }}</span>
  </div>
</ng-template>
